import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { accLtv, accLtv_currency, accountltvCurrencyOther } from "@/api/dataAll/accountLtv";
import * as echarts from "echarts";
export default {
  name: "dataLtv",
  mixins: [tabulation],
  data: function data() {
    return {
      value2: [],
      tableData: [],
      dates: [],
      series: [],
      intReq: [],
      Dynamic: [],
      PrimitiveDy: [],
      screen: [],
      cellStylekeys: ["LTV"],
      searchData: {
        kind: 1
      },
      dimenList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }]
    };
  },
  created: function created() {},
  methods: {
    searchClickNew: function searchClickNew() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.timeInterval();

              case 2:
                reqFn = accLtv;

                if (_this.currencyClose && !_this.searchData.pay_channel) {
                  reqFn = accLtv_currency;
                } else if (_this.searchData.pay_channel) {
                  reqFn = accountltvCurrencyOther;
                }

                _this.screen = [];
                _this.PrimitiveDy = [];

                _this.searchClickPoints(reqFn, 1);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(qudata) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, allAmount, DynamicList, k, _k, data, obj, j;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (qudata.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                res = {
                  account_total: 0,
                  ltv_data: {},
                  ltv_total: {}
                };
                allAmount = {};
                qudata.forEach(function (i) {
                  res.account_total = res.account_total + i.account_total;
                  res.ltv_data = _objectSpread(_objectSpread({}, res.ltv_data), i.ltv_data);

                  for (var k in i.ltv_data) {
                    for (var j in i.ltv_data[k].amount) {
                      if (!allAmount.hasOwnProperty(j)) {
                        allAmount[j] = 0;
                      }

                      allAmount[j] = allAmount[j] + i.ltv_data[k].amount[j];
                    }
                  }
                });
                DynamicList = [];

                for (k in allAmount) {
                  res.ltv_total[k] = res.account_total ? allAmount[k] / res.account_total : 0;
                  DynamicList.push({
                    label: "LTV".concat(k),
                    prop: 'LTV' + k,
                    tableText: k == 1 ? "LTV".concat(k, "A") : "LTV".concat(k),
                    desc: k == 1 ? _this2.$t('firstDayUserAverageValue') : ''
                  });
                }

                if (!_this2.screen.length) {
                  _this2.screen = DynamicList.map(function (item) {
                    return item.prop;
                  });
                }

                _this2.PrimitiveDy = [].concat(DynamicList);
                _context2.next = 11;
                return _this2.timeInterval();

              case 11:
                _this2.tableData = [];
                _this2.dates = [];
                _this2.series = [];
                delete res.ltv_total['0'];
                res.ltv_data[_this2.$t('total')] = {
                  ltv: res.ltv_total,
                  other: {
                    new_account_num: res.account_total
                  }
                };

                for (_k in res.ltv_data) {
                  data = {
                    date: _k,
                    new_account_num: res.ltv_data[_k].other.new_account_num
                  };

                  _this2.dates.push(_k);

                  obj = {
                    name: _k,
                    type: "line",
                    data: [],
                    smooth: true
                  };

                  for (j in res.ltv_data[_k].ltv) {
                    data['LTV' + j] = res.ltv_data[_k].ltv[j] == '/' ? 0.000 : _this2.$utils.conversion(res.ltv_data[_k].ltv[j]).toFixed(3);
                    obj.data.push(data['LTV' + j]);
                  }

                  _this2.series.push(obj);

                  _this2.tableData.push(data);
                }

                _this2.screenControls();

                _this2.$nextTick(function () {
                  _this2.getechart();

                  _this2.getTableRight();
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 20);
      this.setTableRight(0);
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("dataLtvEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dateCp = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      option = {
        title: {
          text: this.$t('accountLtv')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dateCp,
          width: '80%'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.prop;
          })
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('registerNumColumnText'),
        prop: 'new_account_num'
      }].concat(_toConsumableArray(this.Dynamic));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};